// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'

import router from './router'
import "./public/md5";
import axios from './http/index'
import './public/public.js'
import store from "./store/index.js"
import Navigation from 'vue-navigation'
Vue.use(Navigation, { router, store })
import {
  share,
  config
} from './public/share.js'
import {
  vueOpenAppPublic
} from './public/vueOpenAppPublic.js'

vueOpenAppPublic(Vue)
{
  // Vue.use(VueLazyload)

  // or with options
  // const loadimage = require('./assets/loading.gif')
  const errorimage = require('./image/ico_default_img.png')
  Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: errorimage,
    // loading: loadimage,
    attempt: 1
  })
}
Vue.prototype.$axios = axios

import qs from 'qs';
Vue.prototype.$qs = qs

Vue.config.productionTip = false;

import vueSwiper from 'vue-awesome-swiper'

import 'swiper/swiper-bundle.css'


import nav from './components/nav.vue'
import inputNumber from "./components/inputNumber.vue";
Vue.component('Nav', nav)
Vue.component('inputNumber', inputNumber)

import 'vue2-toast/lib/toast.css';
import Toast from 'vue2-toast';
Vue.use(Toast, {
  // wordWrap: true,
  type: 'center',
  duration: 3000,
  wordWrap: true,
  width: '80%'
});


import commentItem from "./page/comment/Item";
import commentItemReply from "./page/comment/ItemReply";
import inputTopic from "./components/inputTopic";
import empty from "./components/empty";
import divS from "./components/divS";
import chapter from "./components/chapter";
import launchWeapp from "./components/launchWeapp";
import Hierarchy from "./page/comment/Hierarchy";
Vue.component('Hierarchy', Hierarchy)
Vue.component('launchWeapp', launchWeapp)
Vue.component('Chapter', chapter)
Vue.component('divS', divS)
Vue.component('empty', empty)
Vue.component('inputTopic', inputTopic)
Vue.component('commentItem', commentItem)
Vue.component('commentItemReply', commentItemReply)

// import { Lazyload } from 'vant';

// Vue.use(Lazyload);



Vue.use(vueSwiper)
share(Vue)
config(Vue)




Vue.prototype.des = function (s, iv, key) {
  return CryptoJS.DES.encrypt(s, CryptoJS.enc.Utf8.parse(key), {
    iv: CryptoJS.enc.Utf8.parse(iv),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString();
}

Vue.prototype.getWxCode = function () {
  if (!is_weixn()) {
    this.$toast.center('请在微信内打开链接')
    return
  }
  if (localStorage.getItem('openid')) {
    return false
  }
  console.log(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wxAppId}&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_userinfo&state=wecedirect`)
  //不存在就打开上面的地址进行授权
  window.location.href =
    `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wxAppId}&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_userinfo&state=wecedirect`;
  return true
}


import VConsole from 'vconsole'


Vue.prototype.VConsole_show = function () {
  if (localStorage.getItem('VConsole_show') == 1) {
    new VConsole()
  }
}

import "./directive/index.js"

Vue.config.ignoredElements = [
  'wx-open-launch-app', 'wx-open-launch-weapp'
]
import App from './App'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  store,
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js